// jshint esversion: 8

export default {
  getQuoted: state => state.data,
  getBooked: state => state.data.filter(q => q.trip.booked),
  getCompleted: state => state.data.filter(q => q.trip.complete),
  getCancelled: state => state.data.filter(q => q.trip.cancelled),
  getLength: state => state.length,
  getNBooked: state => state.booked,
  getNCompleted: state => state.completed,
  last: state => n => state.data.slice(-n), // n = 0 returns all
  // paramInLastN (booked in last 5)
  // lastNWithParam (last 5 booked)
  byId: state =>
    id => state.data.find(
      item => item.id === id),
  byRange: state =>
    range => state.data.filter(
      item => range.lower < item[range.type] && item[range.type] < range.upper),
  filter: state =>
    (field, desired) => state.data.filter(
      item => item[field] === desired),
  lastUpdated: state => state.updated
};
